module.exports = __webpack_public_path__ + "static/sinkhole-c8307c8f66a330243e3e97d8d6a8acb6.jpg";